import { render, staticRenderFns } from "./v-textarea-autocomplete.vue?vue&type=template&id=174a2be7"
import script from "./v-textarea-autocomplete.vue?vue&type=script&lang=js"
export * from "./v-textarea-autocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports